import { combineReducers, createStore, applyMiddleware } from "redux";
import type { AnyAction, Action } from "redux";
import { createLogger } from 'redux-logger';

/*------------- USERS -------------*/
// INTERFACES TAKEN FROM ZEON-DALBELLO.SYSTEM.PARAMS
export interface IFSDibaFlags {
  bom: boolean;
  routings: boolean;
  buyer: boolean;
  costs: boolean;
}

export interface IFSDisMagFlags {
  timing: boolean; // if show total on last date insted of date details
  quantity: boolean; // if true show only >10 instead of real quantity
  only_on_hand: boolean; // if true show only on hand products instead of purchased and/or shopped
}

export interface IFSUserParams {
  sites: string[];
  commodities: string[],
  locations: string[],
  defaults: {
    site: string;
    location: string;
    commodity: string;
  };
  diba: IFSDibaFlags;
  dismag: IFSDisMagFlags;
}

export interface IFSUser {
  username: string;
  params: IFSUserParams;
}

interface IStoreIFSUserAction extends Action {
  type: string,
  payload: IFSUser[] | null
}
export enum ifsUserActionType { "users" }
export const ifsUserAction = (action: ifsUserActionType, userList: IFSUser[] | null): IStoreIFSUserAction => {
  let payload = userList;
  return { type: `ifs.${ifsUserActionType[action]}`, payload }
}

/*------------- STORE -------------*/
interface IBootMetrix {
  begin: number,
  end: number
}

export interface IStoreInitialState {
  boot: IBootMetrix,
  users: IFSUser[] | null
}

const initialState: IStoreInitialState = {
  boot: {
    begin: 0,
    end: 0
  },
  users: null
}
const storeReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case 'ifs.users':
      return Object.assign({}, state, { users: action.payload });
    default:
      return state
  }
}

const fakeReducer = (state = initialState, action: AnyAction) => {
  return state;
}

const reducers = combineReducers({ store: storeReducer, fake: fakeReducer })

export const store = createStore(reducers);
/*
const logger = createLogger();
export const store = createStore(reducers, applyMiddleware(logger));
*/